var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H16L19 22L14 23L11 11Z",
    fill: "#3F3E9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H8L5 22L10 23L13 11Z",
    fill: "#3F3E9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0L13.9283 2.06541L16.7023 1.52786L17.0483 4.33222L19.6085 5.52786L18.24 8L19.6085 10.4721L17.0483 11.6678L16.7023 14.4721L13.9283 13.9346L12 16L10.0717 13.9346L7.29772 14.4721L6.95173 11.6678L4.39155 10.4721L5.76 8L4.39155 5.52786L6.95173 4.33222L7.29772 1.52786L10.0717 2.06541L12 0Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L13.4462 3.54906L15.5267 3.1459L15.7862 5.24917L17.7063 6.1459L16.68 8L17.7063 9.8541L15.7862 10.7508L15.5267 12.8541L13.4462 12.4509L12 14L10.5538 12.4509L8.47329 12.8541L8.2138 10.7508L6.29366 9.8541L7.32 8L6.29366 6.1459L8.2138 5.24917L8.47329 3.1459L10.5538 3.54906L12 2Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.082 11.3594H13.332V11.1094V4V3.75H13.082H12.9307H12.8887L12.8489 3.76373L9.72883 4.84283L9.56055 4.90104V5.0791V6.3291V6.6626L9.88066 6.56907L11.1816 6.18896V11.1094V11.3594H11.4316H13.082Z",
    fill: "#F9F9F9",
    stroke: "#171C2B",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/Gold.823aae9304b4a63a6f5da1a9db53c9cb.svg";
export { ForwardRef as ReactComponent };